import { internal, template } from '../../vendor/elix.js';

function CheckableStylesMixin(Base) {
  return class CheckableStyles extends Base {
    get [internal.template]() {
      return template.concat(
        super[internal.template],
        template.html`
          <style>
          :host {
            display: inline-block;
          }
          .checkable {
            cursor: pointer;
            height: var(--tp-checkable-size);
            line-height: initial;
            position: relative;
            text-align: initial;
            width: var(--tp-checkable-size);
          }
          .checkable__input {
            cursor: pointer;
            height: var(--tp-checkable-size);
            margin: 0;
            opacity: 0;
            padding: 0;
            width: var(--tp-checkable-size);
          }
          .checkable__background {
            box-sizing: border-box;
            display: inline-block;
            font-size: 16px;
            height: 50%;
            left: 0;
            pointer-events: none;
            position: absolute;
            top: 0;
            transform: translateX(50%) translateY(50%);
            width: 50%;
          }
          .checkable__outer-border {
            border-radius: 50%;
            box-sizing: border-box;
            border-width: var(--tp-checkable-border-size);
            border-style: solid;
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 2;
          }
          .checkable__inner-element {
            pointer-events: none;
            position: absolute;
            transform: scale(0);
            transition: var(--tp-checkable-transition-time) ease transform;
            z-index: 2;
          }
          .checkable__input:checked + .checkable__background .checkable__outer-border {
            border-color: var(--tp-checkable-color-selected);
          }
    
          .checkable__background::before,
          .checkable__background::after {
            background: var(--tp-checkable-color-selected);
            border-radius: 50%;
            content: '';
            display: block;
            height: var(--tp-checkable-size);
            opacity: 0;
            position: absolute;
            transform: scaleX(1) scaleY(1) translateX(-25%) translateY(-25%);
            width: var(--tp-checkable-size);
          }      
          .checkable__background::after {
            background: #bfd5e4;
            top: 0;
            transition: 100ms opacity ease-out;
            z-index: 1;
          }
          
          :host(:focus) {
            border: none;
            outline: none;
          }
          
          .checkable__input:focus + .checkable__background::before, 
          :host(:focus) .checkable__background::before,
          :host(:hover) .checkable__background::before {
            opacity: .1;
          }
          
          :host(:hover) .checkable__outer-border {
            border-color: var(--tp-checkable-color-selected);
          }
          
          
          .checkable.pressed .checkable__background::after {
            animation: expando-circle 170ms; 
            opacity: 1;
          }
          @keyframes expando-circle {   
            0%  { transform: scale(.5) translateX(-50%) translateY( -50%); }
            100% { transform: scale(1) translateX(-25%) translateY(-25%); }
          }

          </style>
        `
      );
    }
  }
}

export default CheckableStylesMixin;
